import InfoButton from '../components/InfoButton';
import handleInputChange from '../function/HandleInputsChange';
import CustomSelect from './CustomSelect';

function RenderTrackOption({
  inputs,
  setInputs,
  options,
  setOptions,
  input_name,
  index,
}) {
  const option = options.find((o) => o.field === input_name);
  if (!option) return null;

  const value = option.value?.[index];
  const required = option.required;

  const missing =
    required && [null, undefined, '', 'select an option'].includes(value);

  const handleChange = (newValue) => {
    const updated = { ...(inputs[option.field] || {}), [index]: newValue };
    handleInputChange(option.field, updated, inputs, setInputs, setOptions);
  };

  let inputRender = null;

  if (option.input === 'select') {
    inputRender = (
      <div className="input">
        <CustomSelect
          value={value}
          disabled={option.options.length === 1}
          optionChoice={option.options}
          onChange={handleChange}
        />
      </div>
    );
  }

  if (option.input === 'float_field') {
    inputRender = (
      <div className="input">
        <input
          type="number"
          value={value ?? option.default ?? ''}
          onChange={(e) => handleChange(e.target.value)}
        />
        {missing && <InfoButton infoText="input required" type="warning" />}
      </div>
    );
  }

  return <td className="table-value">{inputRender}</td>;
}

export default RenderTrackOption;
